import type { WorkspaceResponseV2 } from '@emma/api_client/types';
import { EventConnectionTable } from '@/components/event_connection';

type Props = {
  workspace: WorkspaceResponseV2;
};

export const WorkspaceEventConnectionsSubPage = (props: Props) => {
  return <EventConnectionTable workspaceId={props.workspace.id} />;
};
